import React, { Fragment, useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faHome,
  faClock,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { Dialog, Transition } from "@headlessui/react";

import Button from "components/Button";
import Process from "components/Process";
import Services from "components/Services";
import WhyUs from "components/WhyUs";

import "./App.css";

export default function App() {
  const handleSubmitForm = (e) => {
    e.preventDefault();

    // TODO: check Netlify form submit process
    // TODO: replace form content with success or fail message
  };

  const phrases = [
    "first home",
    "next home",
    "dream home",
    "new office",
    "mountain cabin",
    "lakehouse",
  ];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      // update current word
      setIndex((index) => (index + 1) % phrases.length);
    }, 3500); // every 3.5 seconds

    return () => clearInterval(interval);
  });

  const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);

  return (
    <div className="bg-ciWhite" role="main">
      {/* HEADER */}
      <div className="relative flex flex-col justify-center items-center h-big bg-houseSm md:bg-houseLg bg-cover md:bg-center">
        <div className="bg-logo bg-center bg-contain bg-no-repeat w-32 h-32 relative lg:top-3"></div>

        <div className="w-screen my-4 px-1 text-shadow leading-snug tracking-wider text-white text-center text-4xl md:text-5xl lg:text-7xl max-w-7xl font-black">
          <p>Buy your</p>{" "}
          <p className="text-ciGreen-poppin">{phrases[index]}</p>{" "}
          <p>with confidence</p>
        </div>

        <div className="absolute -bottom-6">
          <Button
            onClick={() => setIsScheduleDialogOpen(true)}
            icon="faCalendarAlt"
            text="Schedule Your Inspection"
          ></Button>
        </div>
        <Transition appear show={isScheduleDialogOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={() => setIsScheduleDialogOpen(false)}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block w-full max-w-5xl p-6 my-8 overflow-hidden text-center align-middle transition-all transform bg-white shadow-xl rounded">
                  <Dialog.Title className="text-xl font-medium leading-6">
                    Schedule Your Inspection
                  </Dialog.Title>
                  <div className="mt-2">
                    <object
                      data="https://inspectionsupport.com/core-inspectionllc/online-scheduler/3899349e-d812-11eb-8e29-0a4ef934752f"
                      className="w-full"
                      style={{ height: "50vh" }}
                      type="text/html"
                    >
                      Scheduler
                    </object>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium bg-ciGreen-light text-white border border-transparent rounded hover:bg-ciGreen-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-500"
                      onClick={() => setIsScheduleDialogOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>

      {/* WHY US */}
      <WhyUs />

      {/* SERVICES */}
      <Services />

      {/* PROCESS */}
      <Process />

      {/* CONTACT FORM */}
      <div className="mt-14 px-2 text-center max-w-6xl m-auto">
        <p
          className="leading-snug tracking-wider text-center text-4xl font-extrabold"
          role="heading"
          aria-level="1"
        >
          Get in Touch
        </p>

        <p>We'll reply within a business day.</p>

        <form
          name="contact"
          method="POST"
          data-netlify="true"
          onSubmit={handleSubmitForm}
          className="bg-ciGreen bg-opacity-70 flex flex-col items-center space-y-4 my-3 py-5 rounded-md"
        >
          <p>
            <label className="tracking-wider font-bold flex flex-col text-white">
              Your Name{" "}
              <input
                className="w-60 p-2 text-center text-black rounded-sm"
                type="text"
                name="name"
              />
            </label>
          </p>
          <p>
            <label className="tracking-wider font-bold flex flex-col text-white">
              Your Email{" "}
              <input
                className="w-60 p-2 text-center text-black rounded-sm"
                type="email"
                name="email"
              />
            </label>
          </p>
          <p>
            <label className="tracking-wider font-bold flex flex-col items-center text-white">
              Message{" "}
              <textarea
                className="w-60 md:w-96 h-16 p-1 text-black rounded-sm"
                name="message"
              ></textarea>
            </label>
          </p>
          <p>
            <button
              className="font-bold bg-white px-10 py-2 rounded-sm hover:bg-ciWhite flex items-center"
              type="submit"
            >
              <p className="mr-4">Send</p>
              <FontAwesomeIcon icon={faPaperPlane} />
            </button>
          </p>
        </form>
      </div>

      {/* Footer */}
      <div className="w-full bg-ciGreen-dark text-white py-4 flex flex-col space-y-5">
        <div className="flex flex-col space-y-3 items-center">
          <div className="bg-vetOwned h-28 w-28 mt-5 bg-contain bg-center bg-no-repeat"></div>
          <a
            href="https://www.facebook.com/coreinspect/"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FontAwesomeIcon icon={faFacebookSquare} size="3x" />
          </a>
          <div className="flex items-center space-x-2">
            <a href="tel:+17062065512">
              <FontAwesomeIcon icon={faPhone} /> (706) 206-5512
            </a>
          </div>
          <div className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faHome} />
            <p>P.O. Box 492 Crawford, GA 30630</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex space-x-2">
              <FontAwesomeIcon icon={faClock} />
              <p>Hours</p>
            </div>
            <p>Monday - Friday ... 8am - 6pm</p>
            <p>Saturday ... 8am - 2pm</p>
          </div>
          <div className="text-center text-xs py-4">
            <p>© Copyright 2021 by Core Inspection, LLC</p>
          </div>
        </div>
      </div>
    </div>
  );
}
